export enum COMPANY_STATUSES {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}
